import { enumToString } from '../util';

export const LOCATION_TYPES = {
  DOCTOR: { label: 'Doctor', value: 0 },
  PHARMACY: { label: 'Pharmacy', value: 1 },
  HOME: { label: 'Home', value: 2 },
  toString(value) {
    return enumToString(this, value);
  },
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/notificationTemplates/constants.js